export enum CheckboxValue {
	DetailedView = 'Detailed View',
	AllSessions = 'AllSessions',
}
